/** SSR vs browser; kept separate from `helpers/index` to avoid circular imports (e.g. multistore ↔ helpers ↔ url). */
export const isServer: boolean = typeof window === 'undefined'
